import { useState } from "react"
import { AiFillStar } from 'react-icons/ai'

import { sendRequest } from "./Global/functions"
import { validateEmail } from "./Login/validation"

import { cme_kurs } from "./Global/Kurs"
import * as GoogleAnalytics from "./Global/GoogleAnalytics"

const FeedbackContainer = ({ userMail = "" }) => {

    // -- input-values
    const [mail, setMail] = useState(userMail);
    const [text, setText] = useState("");

    // -- feedback got sent
    const [feedbackSent, setFeedbackSent] = useState(false);

    // -- star-rating got sent
    const [ratingSent, setRatingSent] = useState(false);


    // -- send mail-address and text to backend
    const sendFeedbackMail = async (e) => {
        e.preventDefault();

        // error-message
        const errorMessage = document.querySelector('.feedback-form-error-msg');
        errorMessage.innerHTML = "";

        // request-body
        const body = {
            "Text": text,
            "Mail": mail,
            "KursTitel": cme_kurs.KursTitel
        }

        if (body.Text && validateEmail(body.Mail)) {
            setFeedbackSent(true);


            // send request to backend
            const response = await sendRequest('POST', '/feedback', body);

            if (response.success) {
                // send to feedback-text ga4
                const obj = {
                    "feedback_text": text,
                    'VNR': cme_kurs.VNR,
                    'KursTitel': cme_kurs.KursTitel,
                    'KursKey': cme_kurs.KursKey,
                    'KursTyp': cme_kurs.KursTyp,
                    'Sponsor': cme_kurs.Sponsor_Name
                }
                GoogleAnalytics.sendToGa4('feedback_event', obj);
            }
        }
        else {
            errorMessage.innerHTML = "Bitte tragen Sie eine gültige E-Mail und einen Feedback-Text ein"
        }
    }




    return (
        <div className="feedback-form">

            <div className="sectionTitel">Ihre Meinung ist uns wichtig</div>
            {/* Umfrage form */}
            {
                cme_kurs.url_Umfrage ?
                    <>
                        <div className="feedbackSubTitel">Umfrage</div>
                        <div>Wir sind bestrebt unseren Service für Sie stetig zu verbessern. Bitte nehmen Sie an unserer kurzen, anonymen Umfrage zum Kurs teil. Vielen Dank!</div>
                        <a href={cme_kurs.url_Umfrage} target="_blank" rel="noopener noreferrer" >
                            <button className="feedback-form-submit  my-btn">Zur Umfrage</button>
                        </a>

                    </>

                    : <></>
            }


            {!feedbackSent ?
                // feedback not sent yet
                <>
                    <form className="form-input-container" onSubmit={sendFeedbackMail}>
                        {/* header */}

                        <div className="feedbackSubTitel">Anregungen oder Fragen</div>


                        {/* users mail - dont display if usermail is already defined */}
                        {!userMail ?
                            <div className="textinput-container">
                                <input name="mailInput" id="mailInput" type="text" placeholder="E-Mail" value={mail} onChange={(e) => setMail(e.currentTarget.value)} />
                            </div>
                            : <></>
                        }

                        {/* users mail */}
                        <div className="textinput-container">
                            <textarea name="textInput" id="textInput" type="text" placeholder="Feedback" value={text} onChange={(e) => setText(e.currentTarget.value)} />
                        </div>

                        <div className="feedback-form-error-msg textinput-container" style={{ color: "red" }}></div>

                        {/* submit-btn */}
                        <input onClick={sendFeedbackMail} className="feedback-form-submit  my-btn" type="submit" value="Feedback senden" />
                    </form>

                </>
                :
                // feedback got sent already                
                <div className="rating-feedback-info">Vielen Dank für Ihr Feedback!</div>
            }



            {/* link to cmeducation */}
            {!ratingSent ?

                // rating not sent yet
                <div className="form-input-container">
                    <div className="feedbackSubTitel">Bewertung</div>
                    <a className="rating-link my-btn" href={cme_kurs.cmeducationURL} target='_blank' rel="noreferrer" onClick={() => setRatingSent(true)} >
                        <div>Bitte bewerten Sie diesen Kurs auf CMEducation.de</div>
                        <div className="rating-link-stars"><AiFillStar /><AiFillStar /><AiFillStar /><AiFillStar /><AiFillStar /></div>
                    </a>
                </div>
                :
                // rating got sent already                
                <div className="rating-feedback-info">Vielen Dank für Ihre Bewertung!</div>

            }

        </div >
    )
}

export default FeedbackContainer